// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.team {
    display: grid;
    grid-template-areas: "left left center center center center center center center center center center";
    grid-template-columns: repeat(12, 1fr);
    gap: var(--space-and-half);    
}
.team__action-link {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: bold !important;
    font-size: var(--space-half-quarter);
    line-height: var(--space);    
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--primary-very-dark-color);
}
.team-tabs {
    padding-top: var(--space-and-half);
}
.team__left-container {
    grid-area: left;
}

.team__right-container {
    grid-area: right;
}
.team__right-container__title {
    margin-top: var(--space-x3);
}
.team__right-container__subtitle {
    margin-top: var(--space-x2);
}
.team__right-container__cta-pages {
    border-top: 1px solid var(--primary-light-color);
    margin-top: var(--space-x2);
    padding-top: var(--space-x2);
}
.team__right-container__cta-pages__text {
    margin-top: var(--space);
    font-size: calc( var(--space) - 2px ) !important;
}
.team__right-container__cta-pages__new {
    margin-top: var(--space-and-half);
    width: 100%;
}

.team__center-container {
    grid-area: center;
}

.team__center-container.new-team {
    grid-area: 1 / 3 / 1 /span 10;
    background-color: var(--white-color);
    border-radius: var(--space);
    /*padding: var(--space);*/
    margin-bottom: var(--space-x2);
    margin-top: var(--space-x2);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);    
}

.team-tabs {
    padding-top: var(--space-and-half);
}

.column-tag.tooltip {
    position: relative;
}

.column-tag.tooltip .column-tag__tooltip-msg{
    visibility: hidden;
    width: 184px;
    background-color: var(--primary-dark-color);
    color: var(--white-color);
    text-align: center;
    border-radius: 12px;
    padding: 8px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1000;
    bottom: 150%;
    
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: 11px;
    line-height: 13px;
}

.column-tag.tooltip.pre_registered .column-tag__tooltip-msg{
    left: -40%;
}

.column-tag.tooltip.registered .column-tag__tooltip-msg{
    left: -65%;
}

.column-tag.tooltip.no_registered .column-tag__tooltip-msg{
    left: -45%;
}

.column-tag.tooltip .column-tag__tooltip-msg::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color:  var(--primary-dark-color) transparent transparent transparent;
  }
  
.column-tag.tooltip:hover .column-tag__tooltip-msg {
    visibility: visible;
}


@media screen and ( max-width: 1024px ) {
    
    .team {
        grid-template-areas: "left left center center center center center center center center center center ";
    }
    .team__right-container, .team__left-container {
        display: none;
    }
    .team__center-container {
        grid-area: center;
    }
}

@media screen and ( max-width: 576px ) {
    
    .team {
        margin: 0;
    }

}

.team__pague{
    margin: 0 var(--space-x3);
    display: grid;
    grid-template-areas: ". left left left center center center center . right right";
    grid-template-columns: repeat(12, 1fr);
    grid-gap: var(--space-and-half);
    gap: var(--space-and-half);
  
}

.team__right-container  {
    grid-area: right;
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/views/TeamView.styles.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sGAAsG;IACtG,sCAAsC;IACtC,0BAA0B;AAC9B;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,4BAA4B;IAC5B,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;AACzC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,gDAAgD;IAChD,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,wBAAwB;IACxB,gDAAgD;AACpD;AACA;IACI,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,iDAAiD;AACrD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;IAC3C,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;;IAEZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;;IAEZ,gCAAgC;IAChC,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,4EAA4E;EAC9E;;AAEF;IACI,mBAAmB;AACvB;;;AAGA;;IAEI;QACI,uGAAuG;IAC3G;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,SAAS;IACb;;AAEJ;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,iFAAiF;IACjF,sCAAsC;IACtC,+BAA+B;IAC/B,0BAA0B;;AAE9B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["\n.team {\n    display: grid;\n    grid-template-areas: \"left left center center center center center center center center center center\";\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--space-and-half);    \n}\n.team__action-link {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: bold !important;\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);    \n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--primary-very-dark-color);\n}\n.team-tabs {\n    padding-top: var(--space-and-half);\n}\n.team__left-container {\n    grid-area: left;\n}\n\n.team__right-container {\n    grid-area: right;\n}\n.team__right-container__title {\n    margin-top: var(--space-x3);\n}\n.team__right-container__subtitle {\n    margin-top: var(--space-x2);\n}\n.team__right-container__cta-pages {\n    border-top: 1px solid var(--primary-light-color);\n    margin-top: var(--space-x2);\n    padding-top: var(--space-x2);\n}\n.team__right-container__cta-pages__text {\n    margin-top: var(--space);\n    font-size: calc( var(--space) - 2px ) !important;\n}\n.team__right-container__cta-pages__new {\n    margin-top: var(--space-and-half);\n    width: 100%;\n}\n\n.team__center-container {\n    grid-area: center;\n}\n\n.team__center-container.new-team {\n    grid-area: 1 / 3 / 1 /span 10;\n    background-color: var(--white-color);\n    border-radius: var(--space);\n    /*padding: var(--space);*/\n    margin-bottom: var(--space-x2);\n    margin-top: var(--space-x2);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);    \n}\n\n.team-tabs {\n    padding-top: var(--space-and-half);\n}\n\n.column-tag.tooltip {\n    position: relative;\n}\n\n.column-tag.tooltip .column-tag__tooltip-msg{\n    visibility: hidden;\n    width: 184px;\n    background-color: var(--primary-dark-color);\n    color: var(--white-color);\n    text-align: center;\n    border-radius: 12px;\n    padding: 8px;\n\n    /* Position the tooltip */\n    position: absolute;\n    z-index: 1000;\n    bottom: 150%;\n    \n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: 11px;\n    line-height: 13px;\n}\n\n.column-tag.tooltip.pre_registered .column-tag__tooltip-msg{\n    left: -40%;\n}\n\n.column-tag.tooltip.registered .column-tag__tooltip-msg{\n    left: -65%;\n}\n\n.column-tag.tooltip.no_registered .column-tag__tooltip-msg{\n    left: -45%;\n}\n\n.column-tag.tooltip .column-tag__tooltip-msg::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color:  var(--primary-dark-color) transparent transparent transparent;\n  }\n  \n.column-tag.tooltip:hover .column-tag__tooltip-msg {\n    visibility: visible;\n}\n\n\n@media screen and ( max-width: 1024px ) {\n    \n    .team {\n        grid-template-areas: \"left left center center center center center center center center center center \";\n    }\n    .team__right-container, .team__left-container {\n        display: none;\n    }\n    .team__center-container {\n        grid-area: center;\n    }\n}\n\n@media screen and ( max-width: 576px ) {\n    \n    .team {\n        margin: 0;\n    }\n\n}\n\n.team__pague{\n    margin: 0 var(--space-x3);\n    display: grid;\n    grid-template-areas: \". left left left center center center center . right right\";\n    grid-template-columns: repeat(12, 1fr);\n    grid-gap: var(--space-and-half);\n    gap: var(--space-and-half);\n  \n}\n\n.team__right-container  {\n    grid-area: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
